import Api from "@/api/programming";
import { useRoute, useRouter } from "vue-router";
import { ref } from "vue";

export default function stories() {
    let models = ref([]);

    let route = useRoute()
    let router = useRouter()

    let baseUrl = process.env.VUE_APP_API;

    let title = ref("");
    let text = ref("");
    let author = ref("");
    let status = ref("");
    let description = ref("");
    let category = ref("");
    let categoryOptions = ref([
        { value: "php", text: "php" },
        { value: "linux", text: "linux" },
        { value: "vue", text: "vue" },
        { value: "yii2", text: "yii2" },
        { value: "javascript", text: "javascript" },
        { value: "mysql", text: "mysql" },
    ]);
    let statusOptions = ref([
        { value: 1, text: "Активный" },
        { value: 0, text: "Не активный" },
    ]);

    const createArticle = async () => {
        await Api.createModel({
            title: title.value,
            description: description.value,
            text: text.value,
            author: author.value,
            status: status.value,
            category: category.value
        });

        router.push("/programming/");
    };

    const updateArticle = async () => {
        await Api.updateModel(route.params.id, {
            title: title.value,
            description: description.value,
            text: text.value,
            author: author.value,
            status: status.value,
            category: category.value
        });

        alert("Статья успешно обновлена");
    }


    const deleteArticle = async () => {
        let isDelete = confirm("Вы действительно хотите удалить статью?");

        if (isDelete === true) {
            await Api.deleteModel(route.params.id);
            router.push("/programming/");
        }
    }


    const getArticle = async () => {
        let response = await Api.getModel(route.params.id);

        title.value = response.data.title;
        text.value = response.data.text;
        description.value = response.data.description;
        author.value = response.data.author;
        status.value = response.data.status;
        category.value = response.data.category;
    }

    const getArticles = async () => {
        let response = await Api.getModels({});
        models.value = response.data;
    }

    return {
        models, getArticles, getArticle, deleteArticle, updateArticle, createArticle, baseUrl, title, description, text, author, status, category, categoryOptions, statusOptions
    };
}
